import { render, staticRenderFns } from "./modalFilesHelp.vue?vue&type=template&id=7120102a"
import script from "./modalFilesHelp.vue?vue&type=script&lang=js"
export * from "./modalFilesHelp.vue?vue&type=script&lang=js"
import style0 from "./modalFilesHelp.vue?vue&type=style&index=0&id=7120102a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports